import { Surgery } from 'common/types'
import { TProcedureFilters } from 'lib/hooks/useFilters'

export const filterSurgeries = (
  surgeries: Surgery[],
  filters: TProcedureFilters
): Surgery[] => {
  if (!surgeries || !surgeries.length) {
    return []
  }

  const hasActiveFilters =
    (filters.locations && filters.locations.length > 0) ||
    (filters.rooms && filters.rooms.length > 0) ||
    !!filters.surgeonName ||
    !!filters.surgeryName ||
    !!filters.patientStatus

  if (!hasActiveFilters) {
    return surgeries
  }

  return surgeries.filter((surgery) => {
    const { visit, procedures } = surgery

    if (filters.locations.length > 0) {
      const department = visit?.location?.department
      if (!department || !filters.locations.includes(department)) {
        return false
      }
    }

    if (filters.rooms.length > 0) {
      const roomNumber = visit?.location?.room
      if (!roomNumber || !filters.rooms.includes(roomNumber)) {
        return false
      }
    }

    if (filters.surgeonName) {
      const provider = visit?.attendingProvider
      if (!provider) {
        return false
      }

      const fullName = `${provider.firstName || ''} ${
        provider.lastName || ''
      }`.trim()
      if (!fullName || fullName !== filters.surgeonName) {
        return false
      }
    }

    if (filters.surgeryName) {
      if (!procedures || !procedures.length) {
        return false
      }

      const hasMatchingProcedure = procedures.some(
        (procedure) =>
          procedure.description && procedure.description === filters.surgeryName
      )

      if (!hasMatchingProcedure) {
        return false
      }
    }

    if (filters.patientStatus) {
      const currentPatientStatus = surgery.patientStatusHistory?.[0]?.status

      const effectiveStatus = currentPatientStatus || 'SCHEDULED'

      if (effectiveStatus !== filters.patientStatus) {
        return false
      }
    }

    return true
  })
}
